export function createBottleBotState() {
  return {
    mode: 'hidden', // 'hidden' | 'open' | 'expanded'
    view: 'chat', // 'chat' | 'history'
    conversations: [],
    conversationsCursor: null,
    conversationsLoaded: false,
    activeConversationId: null,
    messages: [],
    messagesCursor: null,
    typing: false,
    sending: false
  }
}
